/**
 * Preview Environment Configuration
 * 
 * This file is auto-generated during Vercel build
 * Values are injected from Vercel environment variables
 */
export const environment = {
  production: false,
  supabaseUrl: 'https://zzrpnscnjfsdyapuchzb.supabase.co',
  supabaseAnonKey: 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Inp6cnBuc2NuamZzZHlhcHVjaHpiIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NjI3NDE5NTgsImV4cCI6MjA3ODMxNzk1OH0.2rYLvcoP2HpdrEyNpwsvW3cyat3VErI6yRYKka4wAyA',
  encryptionKey: '1e9bba4ed433bb6fddb3719f75729156258b84de0f99af999702e2788c948231'
};
